import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faEnvelope,
  faUtensils,
  faEdit,
  faChartLine,
  faUsers,
  faStore,
  faBell,
  faShoppingCart
} from '@fortawesome/free-solid-svg-icons';

const AdminSidebar = ({ isOpen }) => {
  const location = useLocation();

  const navigationItems = [
    { path: '/admin', icon: faHome, label: 'Dashboard' },
    { path: '/admin/orders', icon: faShoppingCart, label: 'Orders' },
    { path: '/admin/edit-data', icon: faEdit, label: 'Edit Content' },
    { path: '/admin/edit-notices', icon: faBell, label: 'Manage Notices' },
    { path: '/admin/contact-submissions', icon: faEnvelope, label: 'Contact Forms' },
    { path: '/admin/catering-requests', icon: faUtensils, label: 'Catering Requests' },
    { path: '/admin/bcc-emails', icon: faUsers, label: 'BCC Email List' },
    { path: '/admin/data-backup', icon: faStore, label: 'Backup & Restore' },
    { path: '/admin/analytics', icon: faChartLine, label: 'Analytics' },
  ];

  return (
    <aside className={`w-64 print:hidden bg-white shadow-md transition-all duration-300 ${isOpen ? '' : '-ml-64'}`}>
      <div className="h-full flex flex-col">
        {/* Logo/Brand */}
        <div className="p-4 border-b">
          <h1 className="text-xl font-bold text-gray-800">Admin Panel</h1>
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto p-4">
          {navigationItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center space-x-3 p-3 rounded-lg transition-colors ${
                location.pathname === item.path
                  ? 'bg-primary text-white'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <FontAwesomeIcon icon={item.icon} />
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>
      </div>
    </aside>
  );
};

export default AdminSidebar; 